module.exports = __webpack_public_path__ + "img/116.5ba01240.jpg";